import React, { useState, useRef, useEffect, useCallback } from 'react'
import styled from 'styled-components/macro'
import Input from '../Input'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-height: var(--size-spacing-08);
  margin: var(--size-spacing-02) 0;
`

const InputStyled = styled(Input)`
  width: 100%; /* Made the input full width */
  border-radius: 0; /* Removed the border radius */
`

const DeviceApprovalChallengeCode = ({ hasError, onChange, onSend, reset, resetCallback }) => {
  const [code, setCode] = useState('')
  const inputRef = useRef(React.createRef())

  const handleReset = useCallback(() => {
    setCode('')
    resetCallback(false)
  }, [resetCallback])

  const handleChange = value => {
    const newValue = checksIfValueIsANumber(value)
    setCode(newValue)

    onChange && onChange(newValue)
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter' && code.length === 6) onSend && onSend()
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress)
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
    // eslint-disable-next-line
  }, [code, onSend])

  useEffect(() => {
    reset && handleReset()
  }, [reset, handleReset])

  useEffect(() => {
    const DELAY_TIME = 100
    const timeoutId = setTimeout(() => {
      inputRef.current.focus()
    }, DELAY_TIME)

    return () => clearTimeout(timeoutId)
  }, [])

  return (
    <Wrapper>
      <InputStyled
        ref={inputRef}
        type="text"
        maxLength="6"
        value={code}
        placeholder="000000" /* Added placeholder of 6 zeros */
        errorMessage={hasError}
        onChange={e => handleChange(e.target.value)}
      />
    </Wrapper>
  )
}

function checksIfValueIsANumber(value) {
  return /^\d*$/.test(value) ? value : ''
}

export default DeviceApprovalChallengeCode
